/* eslint-disable no-param-reassign  */
import { createSlice } from '@reduxjs/toolkit';
import { indexBy, prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { FETCH_STATUSES } from 'utils/fetchStatusUtils';
import ChatRepository from 'repositories/ChatRepository';

const initialState = {
  chatsLoadingStatus: FETCH_STATUSES.idle,
  chatUpdatingStatus: FETCH_STATUSES.idle,
  chats: {},
};

const chatsSlice = createSlice({
  name: 'chatsSlice',
  initialState,
  reducers: {
    loadChatsStart(state) {
      state.chatsLoadingStatus = FETCH_STATUSES.pending;
    },
    loadChatsSuccess(state, { payload }) {
      state.chatsLoadingStatus = FETCH_STATUSES.fulfilled;
      const { chats } = payload;
      state.chats = indexBy(prop('firebaseChatUid'), chats);
    },
    loadChatsFail(state) {
      state.chatsLoadingStatus = FETCH_STATUSES.failed;
    },
    updateChatStart(state) {
      state.chatUpdatingStatus = FETCH_STATUSES.pending;
    },
    updateChatSuccess(state, { payload }) {
      const { uid, chat } = payload;
      state.chats[uid] = chat;
      state.chatUpdatingStatus = FETCH_STATUSES.fulfilled;
    },
    updateChatFail(state) {
      state.chatUpdatingStatus = FETCH_STATUSES.failed;
    },
  },
});

export const { actions } = chatsSlice;

export default chatsSlice.reducer;

export const useAppActions = () => {
  const dispatch = useDispatch();

  const loadChats = async () => {
    dispatch(actions.loadChatsStart());
    try {
      const { chats } = await ChatRepository.index();
      dispatch(actions.loadChatsSuccess({ chats }));
    } catch (_error) {
      dispatch(actions.loadChatsFail());
    }
  };

  const updateChat = async (uid, attributes) => {
    dispatch(actions.updateChatStart());
    try {
      const { chat } = await ChatRepository.update(uid, attributes);
      dispatch(actions.updateChatSuccess({ uid, chat }));
    } catch (_error) {
      dispatch(actions.updateChatFail());
    }
  };

  return {
    loadChats,
    updateChat,
  };
};
/* eslint-enable no-param-reassign */



// WEBPACK FOOTER //
// ./src/reducers/slices/chatsSlice.js